import { render, staticRenderFns } from "./SVGAdminDeleteRow.vue?vue&type=template&id=3dbab097&scoped=true&"
import script from "./SVGAdminDeleteRow.vue?vue&type=script&lang=js&"
export * from "./SVGAdminDeleteRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbab097",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbab097')) {
      api.createRecord('3dbab097', component.options)
    } else {
      api.reload('3dbab097', component.options)
    }
    module.hot.accept("./SVGAdminDeleteRow.vue?vue&type=template&id=3dbab097&scoped=true&", function () {
      api.rerender('3dbab097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGAdminDeleteRow.vue"
export default component.exports